import React from 'react';
import { observer } from 'mobx-react-lite';
import { ClipboardCopyIcon } from '@radix-ui/react-icons';

import { SingleSelectDropdown } from '../../../components/select-dropdown';
import { Project } from '../../../app/entities';
import { TaskPropertyButton } from './task-property.button';

type TaskStepSelectorProps = {
  // Selected project or predefined project
  project?: Project;
  onChange: (value: string) => void;
  selectedStepId: string | undefined;
  isViewOnly?: boolean;
  withIcon?: boolean;
  placeholder?: string;
  triggerVariant?: 'default' | 'minimal';
};

const TaskStepSelector: React.FC<TaskStepSelectorProps> = observer(
  ({
    project,
    onChange,
    selectedStepId,
    withIcon,
    placeholder = 'Select step',
    isViewOnly,
    triggerVariant = 'default',
  }) => {
    const options: React.ComponentProps<typeof SingleSelectDropdown>['groups'] = project
      ? project.stages
          ?.map((stage) => ({
            title: stage.name,
            items: stage.steps.map((step) => ({
              label: step.displayName,
              value: step._id,
            })),
          }))
          ?.filter((el) => el.items.length)
      : [];

    const handleStepChange = (value?: string) => {
      onChange(value || '');
    };

    return (
      <SingleSelectDropdown
        trigger={(label) => (
          <div onClick={(e) => e.stopPropagation()}>
            {label ? (
              <TaskPropertyButton
                icon={
                  withIcon && (
                    <ClipboardCopyIcon
                      style={{
                        color: isViewOnly
                          ? 'var(--color-grayscale-shuttle)'
                          : 'var(--color-texts-high-contrast)',
                      }}
                    />
                  )
                }
                label={label}
                isActive
              />
            ) : (
              <TaskPropertyButton icon={<ClipboardCopyIcon />} label={placeholder} />
            )}
          </div>
        )}
        title="Step"
        value={selectedStepId}
        groups={options}
        placeholder="Search"
        onValueChange={handleStepChange}
        disabled={isViewOnly || !project}
        align={triggerVariant === 'minimal' ? 'end' : 'start'}
      />
    );
  },
);
export default TaskStepSelector;
